import jqRequest from "../jqRequest";
import newsUrls from "../urls/news";

export default {
  // 获取新闻资讯详情
  getNewsDetailById(data) {
    return jqRequest.requestWithToken(newsUrls.getNewsDetailById, data);
  },
  // 新闻资讯相关推荐、热门评论
  getNewsOthersById(data) {
    return jqRequest.requestWithToken(newsUrls.getNewsOthersById, data);
  },
  // 完成学习
  finishStudy(data) {
    return jqRequest.requestWithToken(newsUrls.finishStudy, data);
  },
  // 提交投票
  addBallotData(data) {
    return jqRequest.requestWithToken(newsUrls.addBallotData, data);
  },
  // 验证是否已投票
  validateHasBallotOrNotByMember(data) {
    return jqRequest.requestWithToken(
      newsUrls.validateHasBallotOrNotByMember,
      data
    );
  },

  getNewsInfo(data) {
    return jqRequest.requestWithContentTypeAndToken(
      newsUrls.getMaterialInfoByKey,
      data
    );
  },

  getSpecialContentsForColumnPage(data) {
    return jqRequest.requestWithContentTypeAndToken(
      newsUrls.getSpecialContentsForColumnPage,
      data,"post","","application/x-www-form-urlencoded; charset=UTF-8",
    );
  },
  beforMaterialInfoByKey(data) {
    return jqRequest.requestWithContentTypeAndToken(newsUrls.beforMaterialInfoByKey, data);
  },
};
